"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _survey = require("./survey.constant");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // @flow
var INIT_STATE = {
  // common
  list: null,
  fetch: null,
  fetchPasscode: null,
  create: null,
  update: null,
  updateDetail: null,
  linkedFund: null,
  saveLinkedFund: null,
  lock: null,
  lockBulk: null,
  unlock: null,
  unlockBulk: null,
  softDelete: null,
  softDeleteBulk: null,
  submit: null,
  submitBulk: null,
  pause: null,
  pauseBulk: null,
  resume: null,
  resumeBulk: null,
  copyUrl: null,
  magicUrl: null,
  download: null,
  downloadAll: null,
  downloadSurveyResponse: null,
  getSurveyPasscode: null,
  // unique url extension
  uniqueUrlExtension: null,
  // deleted data
  softDeleteList: null,
  restore: null,
  restoreBulk: null,
  delete: null,
  deleteBulk: null,
  // uploader
  prefight: null,
  import: null,
  errorSheetDownload: null,
  // analytics
  analyticsSave: null,
  analyticsGet: null,
  analyticsUpdate: null,
  // configuration
  listConfiguration: null,
  fetchConfiguration: null,
  // review and approve
  listReviewApproval: null,
  approve: null,
  approveBulk: null,
  // editor
  editorFetch: null,
  editorSave: null,
  editorChangeBrand: null,
  editorLock: null,
  editorLockExist: null,
  editorUnlock: null,
  // default
  loading: false
};
var survey = function survey() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    // common
    case _survey.actionTypes.LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        list: state.list
      });
    case _survey.actionTypes.FETCH:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetch: state.fetch
      });
    case _survey.actionTypes.FETCH_PASSCODE:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchPasscode: state.fetchPasscode
      });
    case _survey.actionTypes.CREATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        create: state.create
      });
    case _survey.actionTypes.UPDATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        update: state.update
      });
    case _survey.actionTypes.UPDATE_DETAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        updateDetail: state.updateDetail
      });
    case _survey.actionTypes.LINKED_FUND:
      return _objectSpread(_objectSpread({}, state), {}, {
        linkedFund: state.linkedFund
      });
    case _survey.actionTypes.SAVE_LINKED_FUND:
      return _objectSpread(_objectSpread({}, state), {}, {
        saveLinkedFund: state.saveLinkedFund
      });
    case _survey.actionTypes.LOCK:
      return _objectSpread(_objectSpread({}, state), {}, {
        lock: state.lock
      });
    case _survey.actionTypes.LOCK_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        lockBulk: state.lockBulk
      });
    case _survey.actionTypes.UNLOCK:
      return _objectSpread(_objectSpread({}, state), {}, {
        unlock: state.unlock
      });
    case _survey.actionTypes.UNLOCK_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        unlockBulk: state.unlockBulk
      });
    case _survey.actionTypes.SOFT_DELETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        softDelete: state.softDelete
      });
    case _survey.actionTypes.SOFT_DELETE_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        softDeleteBulk: state.softDeleteBulk
      });
    case _survey.actionTypes.SUBMIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        submit: state.submit
      });
    case _survey.actionTypes.SUBMIT_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        submitBulk: state.submitBulk
      });
    case _survey.actionTypes.PAUSE:
      return _objectSpread(_objectSpread({}, state), {}, {
        pause: state.pause
      });
    case _survey.actionTypes.PAUSE_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        pauseBulk: state.pauseBulk
      });
    case _survey.actionTypes.RESUME:
      return _objectSpread(_objectSpread({}, state), {}, {
        resume: state.resume
      });
    case _survey.actionTypes.RESUME_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        resumeBulk: state.resumeBulk
      });
    case _survey.actionTypes.COPY_URL:
      return _objectSpread(_objectSpread({}, state), {}, {
        copyUrl: state.copyUrl
      });
    case _survey.actionTypes.MAGIC_URL:
      return _objectSpread(_objectSpread({}, state), {}, {
        magicUrl: state.magicUrl
      });
    case _survey.actionTypes.DOWNLOAD:
      return _objectSpread(_objectSpread({}, state), {}, {
        download: state.download
      });
    case _survey.actionTypes.DOWNLOAD_ALL:
      return _objectSpread(_objectSpread({}, state), {}, {
        downloadAll: state.downloadAll
      });
    case _survey.actionTypes.DOWNLOAD_SURVEY_RESPONSE:
      return _objectSpread(_objectSpread({}, state), {}, {
        downloadSurveyResponse: state.downloadSurveyResponse
      });
    case _survey.actionTypes.GET_SURVEY_PASSCODE:
      return _objectSpread(_objectSpread({}, state), {}, {
        getSurveyPasscode: state.getSurveyPasscode
      });
    // unique url extension
    case _survey.actionTypes.UNIQUE_URL_EXTENSION:
      return _objectSpread(_objectSpread({}, state), {}, {
        uniqueUrlExtension: state.uniqueUrlExtension
      });
    case _survey.actionTypes.UNIQUE_URL_EXTENSION_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        uniqueUrlExtension: null
      });
    // deleted data
    case _survey.actionTypes.SOFT_DELETE_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        softDeleteList: state.softDeleteList
      });
    case _survey.actionTypes.RESTORE:
      return _objectSpread(_objectSpread({}, state), {}, {
        restore: state.restore
      });
    case _survey.actionTypes.RESTORE_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        restoreBulk: state.restoreBulk
      });
    case _survey.actionTypes.DELETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        delete: state.delete
      });
    case _survey.actionTypes.DELETE_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        deleteBulk: state.deleteBulk
      });
    // uploader
    case _survey.actionTypes.PREFIGHT:
      return _objectSpread(_objectSpread({}, state), {}, {
        prefight: state.prefight
      });
    case _survey.actionTypes.IMPORT:
      return _objectSpread(_objectSpread({}, state), {}, {
        import: state.import
      });
    case _survey.actionTypes.ERROR_SHEET_DOWNLOAD:
      return _objectSpread(_objectSpread({}, state), {}, {
        errorSheetDownload: state.errorSheetDownload
      });
    // analytics
    case _survey.actionTypes.ANALYTICS_SAVE:
      return _objectSpread(_objectSpread({}, state), {}, {
        analyticsSave: state.analyticsSave
      });
    case _survey.actionTypes.ANALYTICS_GET:
      return _objectSpread(_objectSpread({}, state), {}, {
        analyticsGet: state.analyticsGet
      });
    case _survey.actionTypes.ANALYTICS_UPDATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        analyticsUpdate: state.analyticsUpdate
      });
    case _survey.actionTypes.LIST_CONFIGURATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        listConfiguration: state.listConfiguration
      });
    case _survey.actionTypes.FETCH_CONFIGURATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchConfiguration: state.fetchConfiguration
      });
    // review and approve
    case _survey.actionTypes.LIST_REVIEW_APPROVAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        listReviewApproval: state.listReviewApproval
      });
    case _survey.actionTypes.APPROVE:
      return _objectSpread(_objectSpread({}, state), {}, {
        approve: state.approve
      });
    case _survey.actionTypes.APPROVE_BULK:
      return _objectSpread(_objectSpread({}, state), {}, {
        approveBulk: state.approveBulk
      });
    case _survey.actionTypes.REVIEW_APPROVAL_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        approve: null,
        approveBulk: null
      });
    // editor
    case _survey.actionTypes.EDITOR_FETCH:
      return _objectSpread(_objectSpread({}, state), {}, {
        editorFetch: state.editorFetch
      });
    case _survey.actionTypes.EDITOR_SAVE:
      return _objectSpread(_objectSpread({}, state), {}, {
        editorSave: state.editorSave
      });
    case _survey.actionTypes.EDITOR_CHANGE_BRAND:
      return _objectSpread(_objectSpread({}, state), {}, {
        editorChangeBrand: state.editorChangeBrand
      });
    case _survey.actionTypes.EDITOR_LOCK:
      return _objectSpread(_objectSpread({}, state), {}, {
        editorLock: state.editorLock
      });
    case _survey.actionTypes.EDITOR_LOCK_EXIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        editorLockExist: state.editorLockExist
      });
    case _survey.actionTypes.EDITOR_UNLOCK:
      return _objectSpread(_objectSpread({}, state), {}, {
        editorUnlock: state.editorUnlock
      });
    case _survey.actionTypes.EDITOR_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        editorSave: null,
        editorChangeBrand: null,
        editorLock: null,
        editorLockExist: null,
        editorUnlock: null
      });
    case _survey.actionTypes.SUCCESS:
      switch (action.payload.actionType) {
        // common
        case _survey.actionTypes.LIST:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            list: action.payload.data
          });
        case _survey.actionTypes.FETCH:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            fetch: action.payload.data
          });
        case _survey.actionTypes.FETCH_PASSCODE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            fetchPasscode: action.payload.data
          });
        case _survey.actionTypes.CREATE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            create: action.payload.data
          });
        case _survey.actionTypes.UPDATE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            update: action.payload.data
          });
        case _survey.actionTypes.UPDATE_DETAIL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            updateDetail: action.payload.data
          });
        case _survey.actionTypes.LINKED_FUND:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            linkedFund: action.payload.data
          });
        case _survey.actionTypes.SAVE_LINKED_FUND:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            saveLinkedFund: action.payload.data
          });
        case _survey.actionTypes.LOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            lock: action.payload.data
          });
        case _survey.actionTypes.LOCK_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            lockBulk: action.payload.data
          });
        case _survey.actionTypes.UNLOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            unlock: action.payload.data
          });
        case _survey.actionTypes.UNLOCK_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            unlockBulk: action.payload.data
          });
        case _survey.actionTypes.SOFT_DELETE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            softDelete: action.payload.data
          });
        case _survey.actionTypes.SOFT_DELETE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            softDeleteBulk: action.payload.data
          });
        case _survey.actionTypes.SUBMIT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            submit: action.payload.data
          });
        case _survey.actionTypes.SUBMIT_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            submitBulk: action.payload.data
          });
        case _survey.actionTypes.PAUSE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            pause: action.payload.data
          });
        case _survey.actionTypes.PAUSE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            pauseBulk: action.payload.data
          });
        case _survey.actionTypes.RESUME:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            resume: action.payload.data
          });
        case _survey.actionTypes.RESUME_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            resumeBulk: action.payload.data
          });
        case _survey.actionTypes.COPY_URL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            copyUrl: action.payload.data
          });
        case _survey.actionTypes.MAGIC_URL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            magicUrl: action.payload.data
          });
        case _survey.actionTypes.DOWNLOAD:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            download: action.payload.data
          });
        case _survey.actionTypes.DOWNLOAD_ALL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            downloadAll: action.payload.data
          });
        case _survey.actionTypes.DOWNLOAD_SURVEY_RESPONSE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            downloadSurveyResponse: action.payload.data
          });
        case _survey.actionTypes.GET_SURVEY_PASSCODE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            getSurveyPasscode: action.payload.data
          });
        // unique url extension
        case _survey.actionTypes.UNIQUE_URL_EXTENSION:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            uniqueUrlExtension: action.payload.data
          });
        // deleted data
        case _survey.actionTypes.SOFT_DELETE_LIST:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            softDeleteList: action.payload.data
          });
        case _survey.actionTypes.RESTORE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            restore: action.payload.data
          });
        case _survey.actionTypes.RESTORE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            restoreBulk: action.payload.data
          });
        case _survey.actionTypes.DELETE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            delete: action.payload.data
          });
        case _survey.actionTypes.DELETE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            deleteBulk: action.payload.data
          });
        // uploader
        case _survey.actionTypes.PREFIGHT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            prefight: action.payload.data
          });
        case _survey.actionTypes.IMPORT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            import: action.payload.data
          });
        case _survey.actionTypes.ERROR_SHEET_DOWNLOAD:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            errorSheetDownload: action.payload.data
          });
        // analytics
        case _survey.actionTypes.ANALYTICS_SAVE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            analyticsSave: action.payload.data
          });
        case _survey.actionTypes.ANALYTICS_GET:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            analyticsGet: action.payload.data
          });
        case _survey.actionTypes.ANALYTICS_UPDATE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            analyticsUpdate: action.payload.data
          });
        case _survey.actionTypes.LIST_CONFIGURATION:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            listConfiguration: action.payload.data
          });
        case _survey.actionTypes.FETCH_CONFIGURATION:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            fetchConfiguration: action.payload.data
          });
        // review and approve
        case _survey.actionTypes.LIST_REVIEW_APPROVAL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            listReviewApproval: action.payload.data
          });
        case _survey.actionTypes.APPROVE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            approve: action.payload.data
          });
        case _survey.actionTypes.APPROVE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            approveBulk: action.payload.data
          });
        // editor
        case _survey.actionTypes.EDITOR_FETCH:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorFetch: action.payload.data
          });
        case _survey.actionTypes.EDITOR_SAVE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorSave: action.payload.data
          });
        case _survey.actionTypes.EDITOR_CHANGE_BRAND:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorChangeBrand: action.payload.data
          });
        case _survey.actionTypes.EDITOR_LOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorLock: action.payload.data
          });
        case _survey.actionTypes.EDITOR_LOCK_EXIST:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorLockExist: action.payload.data
          });
        case _survey.actionTypes.EDITOR_UNLOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorUnlock: action.payload.data
          });
        default:
          return _objectSpread({}, state);
      }
    case _survey.actionTypes.ERROR:
      switch (action.payload.actionType) {
        // common
        case _survey.actionTypes.LIST:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            list: action.payload.error
          });
        case _survey.actionTypes.FETCH:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            fetch: action.payload.error
          });
        case _survey.actionTypes.FETCH_PASSCODE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            fetchPasscode: action.payload.error
          });
        case _survey.actionTypes.CREATE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            create: action.payload.error
          });
        case _survey.actionTypes.UPDATE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            update: action.payload.error
          });
        case _survey.actionTypes.UPDATE_DETAIL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            updateDetail: action.payload.error
          });
        case _survey.actionTypes.LINKED_FUND:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            linkedFund: action.payload.error
          });
        case _survey.actionTypes.SAVE_LINKED_FUND:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            saveLinkedFund: action.payload.error
          });
        case _survey.actionTypes.LOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            lock: action.payload.error
          });
        case _survey.actionTypes.LOCK_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            lockBulk: action.payload.error
          });
        case _survey.actionTypes.UNLOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            unlock: action.payload.error
          });
        case _survey.actionTypes.UNLOCK_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            unlockBulk: action.payload.error
          });
        case _survey.actionTypes.SOFT_DELETE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            softDelete: action.payload.error
          });
        case _survey.actionTypes.SOFT_DELETE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            softDeleteBulk: action.payload.error
          });
        case _survey.actionTypes.SUBMIT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            submit: action.payload.error
          });
        case _survey.actionTypes.SUBMIT_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            submitBulk: action.payload.error
          });
        case _survey.actionTypes.PAUSE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            pause: action.payload.error
          });
        case _survey.actionTypes.PAUSE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            pauseBulk: action.payload.error
          });
        case _survey.actionTypes.RESUME:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            resume: action.payload.error
          });
        case _survey.actionTypes.RESUME_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            resumeBulk: action.payload.error
          });
        case _survey.actionTypes.COPY_URL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            copyUrl: action.payload.error
          });
        case _survey.actionTypes.MAGIC_URL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            magicUrl: action.payload.error
          });
        case _survey.actionTypes.DOWNLOAD:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            download: action.payload.error
          });
        case _survey.actionTypes.DOWNLOAD_ALL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            downloadAll: action.payload.error
          });
        case _survey.actionTypes.DOWNLOAD_SURVEY_RESPONSE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            downloadSurveyResponse: action.payload.error
          });
        case _survey.actionTypes.GET_SURVEY_PASSCODE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            getSurveyPasscode: action.payload.error
          });
        // unique url extension
        case _survey.actionTypes.UNIQUE_URL_EXTENSION:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            uniqueUrlExtension: action.payload.error
          });
        // deleted data
        case _survey.actionTypes.SOFT_DELETE_LIST:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            softDeleteList: action.payload.error
          });
        case _survey.actionTypes.RESTORE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            restore: action.payload.error
          });
        case _survey.actionTypes.RESTORE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            restoreBulk: action.payload.error
          });
        case _survey.actionTypes.DELETE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            delete: action.payload.error
          });
        case _survey.actionTypes.DELETE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            deleteBulk: action.payload.error
          });
        // uploader
        case _survey.actionTypes.PREFIGHT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            prefight: action.payload.error
          });
        case _survey.actionTypes.IMPORT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            import: action.payload.error
          });
        case _survey.actionTypes.ERROR_SHEET_DOWNLOAD:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            errorSheetDownload: action.payload.error
          });
        // analytics
        case _survey.actionTypes.ANALYTICS_SAVE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            analyticsSave: action.payload.error
          });
        case _survey.actionTypes.ANALYTICS_GET:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            analyticsGet: action.payload.error
          });
        case _survey.actionTypes.ANALYTICS_UPDATE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            analyticsUpdate: action.payload.error
          });
        case _survey.actionTypes.LIST_CONFIGURATION:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            listConfiguration: action.payload.error
          });
        case _survey.actionTypes.FETCH_CONFIGURATION:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            fetchConfiguration: action.payload.error
          });
        // review and approve
        case _survey.actionTypes.LIST_REVIEW_APPROVAL:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            listReviewApproval: action.payload.error
          });
        case _survey.actionTypes.APPROVE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            approve: action.payload.error
          });
        case _survey.actionTypes.APPROVE_BULK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            approveBulk: action.payload.error
          });
        // editor
        case _survey.actionTypes.EDITOR_FETCH:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorFetch: action.payload.error
          });
        case _survey.actionTypes.EDITOR_SAVE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorSave: action.payload.error
          });
        case _survey.actionTypes.EDITOR_CHANGE_BRAND:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorChangeBrand: action.payload.error
          });
        case _survey.actionTypes.EDITOR_LOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorLock: action.payload.error
          });
        case _survey.actionTypes.EDITOR_LOCK_EXIST:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorLockExist: action.payload.error
          });
        case _survey.actionTypes.EDITOR_UNLOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorUnlock: action.payload.error
          });
        default:
          return _objectSpread({}, state);
      }
    case _survey.actionTypes.FETCH_CONFIGURATION_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchConfiguration: null,
        loading: false
      });
    case _survey.actionTypes.RESET:
      return _objectSpread({}, INIT_STATE);
    case _survey.actionTypes.UPDATE_DETAIL_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        updateDetail: null
      });
    case _survey.actionTypes.RESET_AVOID:
      return {
        // common
        list: state.list,
        fetch: state.fetch,
        fetchPasscode: null,
        create: null,
        update: null,
        linkedFund: null,
        saveLinkedFund: null,
        lock: null,
        lockBulk: null,
        unlock: null,
        unlockBulk: null,
        softDelete: null,
        softDeleteBulk: null,
        submit: null,
        submitBulk: null,
        pause: null,
        pauseBulk: null,
        resume: null,
        resumeBulk: null,
        copyUrl: null,
        magicUrl: null,
        download: null,
        downloadAll: null,
        downloadSurveyResponse: null,
        // deleted data
        softDeleteList: state.softDeleteList,
        restore: null,
        restoreBulk: null,
        delete: null,
        deleteBulk: null,
        // uploader
        prefight: null,
        import: null,
        errorSheetDownload: null,
        // analytics
        analyticsSave: null,
        analyticsGet: null,
        analyticsUpdate: null,
        // configuration
        listConfiguration: state.listConfiguration,
        fetchConfiguration: state.fetchConfiguration,
        // default
        loading: false
      };
    default:
      return _objectSpread({}, state);
  }
};
var _default = survey;
exports.default = _default;